/* eslint-disable max-len */
/* eslint-disable import/no-named-as-default */
import React from 'react';
import {checkPermission} from 'core/utils';
import {AddressBook, CreateAddress, UpdateAddress} from 'views/addresses';
import Cart from 'views/cart';
import ContactForm from 'views/contact-form';
import CreditSummary from 'views/credit-summary';
import DEN from 'views/den';
import ErrorPage from 'views/error-page';
import FAQ from 'views/faq';
import {FenceSignsDealerCreate, FenceSignsDealerModify} from 'views/fence-signs/dealer';
import {FenceSignsMultiplierCreate, FenceSignsMultiplierModify} from 'views/fence-signs/multiplier';
import Home from 'views/home';
import {LLDealerBagsCreate, LLDealerBagsModify} from 'views/lado-a-lado/dealer/bags';
import LLDealerHome from 'views/lado-a-lado/dealer/home';
import {LLDealerTrialSignsCreate, LLDealerTrialSignsModify} from 'views/lado-a-lado/dealer/signs';
import {LLMultiplierBagsCreate, LLMultiplierBagsModify} from 'views/lado-a-lado/multiplier/bags';
import LLMultiplierHome from 'views/lado-a-lado/multiplier/home';
import {LLMultiplierTrialSignsCreate, LLMultiplierTrialSignsModify} from 'views/lado-a-lado/multiplier/signs';
import Login from 'views/login';
import Merchandising from 'views/merchandising';
import OrderDetail from 'views/order-detail';
import OrderList from 'views/order-list';
import ProductDetail from 'views/product-detail';
import AdvertisingRefundCreate from 'views/refunds/advertising';
import CLDealerCropsCreate from 'views/refunds/cl-dealer/crops';
import CLDealerHome from 'views/refunds/cl-dealer/home';
import CLDealerKitsCreate from 'views/refunds/cl-dealer/kits';
import CLDealerRefundCreate from 'views/refunds/cl-dealer/refund';
import {CLDealerTrialSignsCreate, CLDealerTrialSignsModify} from 'views/refunds/cl-dealer/trial-signs';
import CLMultiplierCropsCreate from 'views/refunds/cl-multiplier/crops';
import CLMultiplierHome from 'views/refunds/cl-multiplier/home';
import CLMultiplierKitsCreate from 'views/refunds/cl-multiplier/kits';
import CLMultiplierRefundCreate from 'views/refunds/cl-multiplier/refund';
import {CLMultiplierTrialSignsCreate, CLMultiplierTrialSignsModify} from 'views/refunds/cl-multiplier/trial-signs';
import DronesRefundCreate from 'views/refunds/drones';
import JTDealerRefundCreate from 'views/refunds/jt-dealer';
import JTMultiplierRefundCreate from 'views/refunds/jt-multiplier';
import LoyaltyRefundCreate from 'views/refunds/loyalty';
import OtherDealerRefundCreate from 'views/refunds/other-dealer';
import OtherMultiplierRefundCreate from 'views/refunds/other-multiplier';
import RTIDealerHome from 'views/refunds/rti-dealer/home';
import RTIDealerKitsCreate from 'views/refunds/rti-dealer/kits';
import RTIDealerRefundCreate from 'views/refunds/rti-dealer/refund';
import RTIMultiplierHome from 'views/refunds/rti-multiplier/home';
import RTIMultiplierKitsCreate from 'views/refunds/rti-multiplier/kits';
import RTIMultiplierRefundCreate from 'views/refunds/rti-multiplier/refund';
import RouteSignsCreate from 'views/route-signs/dealer';
import TermsAndConditions from 'views/terms-and-conditions';
import {Profile} from 'views/users';

export const urlPatterns = [
    {name: 'home', path: '/', component: Home, title: 'Home'},

    {name: 'merchandising', path: '/merchandising/', component: Merchandising, permissions: ['merchandising'], title: 'Merchandising'},
    {name: 'productDetail', path: '/merchandising/:id/', component: ProductDetail, permissions: ['merchandising']},

    {name: 'fenceSignsDealerCreate', path: '/carteles-alambrado-distribuidor/', component: FenceSignsDealerCreate, permissions: ['fenceSignsDealer'], title: 'Carteles de alamabrado'},
    {name: 'fenceSignsDealerModify', path: '/carteles-alambrado-distribuidor/:id/', component: FenceSignsDealerModify, permissions: ['fenceSignsDealer']},
    {name: 'fenceSignsMultiplierCreate', path: '/carteles-alambrado-multiplicador/', component: FenceSignsMultiplierCreate, permissions: ['fenceSignsMultiplier'], title: 'Carteles de alamabrado'},
    {name: 'fenceSignsMultiplierModify', path: '/carteles-alambrado-multiplicador/:id/', component: FenceSignsMultiplierModify, permissions: ['fenceSignsMultiplier']},

    {name: 'clDealerHome', path: '/campo-lider-distribuidor/', component: CLDealerHome, permissions: ['clDealerCrops', 'clDealerRefund', 'clDealerKits', 'clDealerTrialSigns']},
    {name: 'clDealerCropsCreate', path: '/campo-lider-distribuidor/bolsas/', component: CLDealerCropsCreate, permissions: ['clDealerCrops']},
    {name: 'clDealerRefundCreate', path: '/campo-lider-distribuidor/presupuesto/', component: CLDealerRefundCreate, permissions: ['clDealerRefund'], title: 'Campo Líder Distribuidor'},
    {name: 'clDealerKitsCreate', path: '/campo-lider-distribuidor/kits/', component: CLDealerKitsCreate, permissions: ['clDealerKits'], title: 'Campo Líder Distribuidor'},
    {name: 'clDealerTrialSignsCreate', path: '/campo-lider-distribuidor/carteles-ensayo/', component: CLDealerTrialSignsCreate, permissions: ['clDealerTrialSigns'], title: 'Campo Líder Distribuidor'},
    {name: 'clDealerTrialSignsModify', path: '/campo-lider-distribuidor/carteles-ensayo/:id/', component: CLDealerTrialSignsModify, permissions: ['clDealerTrialSigns']},

    {name: 'clMultiplierHome', path: '/campo-lider-multiplicador/', component: CLMultiplierHome, permissions: ['clMultiplierCrops', 'clMultiplierRefund', 'clMultiplierKits', 'clMultiplierTrialSigns']},
    {name: 'clMultiplierCropsCreate', path: '/campo-lider-multiplicador/cultivos/', component: CLMultiplierCropsCreate, permissions: ['clMultiplierCrops']},
    {name: 'clMultiplierRefundCreate', path: '/campo-lider-multiplicador/presupuesto/', component: CLMultiplierRefundCreate, permissions: ['clMultiplierRefund']},
    {name: 'clMultiplierKitsCreate', path: '/campo-lider-multiplicador/kits/', component: CLMultiplierKitsCreate, permissions: ['clMultiplierKits']},
    {name: 'clMultiplierTrialSignsCreate', path: '/campo-lider-multiplicador/carteles-ensayo/', component: CLMultiplierTrialSignsCreate, permissions: ['clMultiplierTrialSigns']},
    {name: 'clMultiplierTrialSignsModify', path: '/campo-lider-multiplicador/carteles-ensayo/:id/', component: CLMultiplierTrialSignsModify, permissions: ['clMultiplierTrialSigns']},

    {name: 'rtiDealerHome', path: '/rti-distribuidor/', component: RTIDealerHome, permissions: ['rtiDealerRefund', 'rtiDealerKits']},
    {name: 'rtiDealerRefundCreate', path: '/rti-distribuidor/presupuesto/', component: RTIDealerRefundCreate, permissions: ['rtiDealerRefund']},
    {name: 'rtiDealerKitsCreate', path: '/rti-distribuidor/kits/', component: RTIDealerKitsCreate, permissions: ['rtiDealerKits']},
    {name: 'rtiMultiplierHome', path: '/rti-multiplicador/', component: RTIMultiplierHome, permissions: ['rtiMultiplierRefund', 'rtiMultiplierKits']},
    {name: 'rtiMultiplierRefundCreate', path: '/rti-multiplicador/presupuesto/', component: RTIMultiplierRefundCreate, permissions: ['rtiMultiplierRefund']},
    {name: 'rtiMultiplierKitsCreate', path: '/rti-multiplicador/kits/', component: RTIMultiplierKitsCreate, permissions: ['rtiMultiplierKits']},

    {name: 'drones', path: '/drones/', component: DronesRefundCreate, permissions: ['otherDealerRefund'], title: 'Drones'},

    {name: 'RouteSignsCreate', path: '/carteles-ruta/', component: RouteSignsCreate, permissions: ['routeSignsDealerRefund'], title: 'Carteles en ruta'},

    {name: 'otherDealerRefundCreate', path: '/otras-acciones-distribuidor/', component: OtherDealerRefundCreate, permissions: ['otherDealerRefund'], title: 'Otras acciones'},
    {name: 'otherMultiplierRefundCreate', path: '/otras-acciones-multiplicador/', component: OtherMultiplierRefundCreate, permissions: ['otherMultiplierRefund'], title: 'Otras acciones'},

    {name: 'loyaltyRefundActions', path: '/acciones-de-fidelizacion/', component: LoyaltyRefundCreate, permissions: ['otherDealerRefund'], title: 'Viajes de Fidelización'},

    {name: 'jtDealerRefundCreate', path: '/jornadas-tecnicas-distribuidor/', component: JTDealerRefundCreate, permissions: ['jtDealerRefund']},
    {name: 'jtMultiplierRefundCreate', path: '/jornadas-tecnicas-multiplicador/', component: JTMultiplierRefundCreate, permissions: ['jtMultiplierRefund']},

    {name: 'advertisingRefundCreate', path: '/publicidad/', component: AdvertisingRefundCreate, permissions: ['advertisingRefund'], title: 'Publicidad'},

    {name: 'llDealerHome', path: '/lado-a-lado-distribuidor/', component: LLDealerHome, permissions: ['llDealerBags', 'llDealerTrialSigns']},
    {name: 'llDealerBagsCreate', path: '/lado-a-lado-distribuidor/bolsas/', component: LLDealerBagsCreate, permissions: ['llDealerBags']},
    {name: 'llDealerBagsModify', path: '/lado-a-lado-distribuidor/bolsas/:id/', component: LLDealerBagsModify, permissions: ['llDealerBags']},
    {name: 'llDealerTrialSignsCreate', path: '/lado-a-lado-distribuidor/carteles/', component: LLDealerTrialSignsCreate, permissions: ['llDealerTrialSigns']},
    {name: 'llDealerTrialSignsModify', path: '/lado-a-lado-distribuidor/carteles/:id/', component: LLDealerTrialSignsModify, permissions: ['llDealerTrialSigns']},
    {name: 'llMultiplierHome', path: '/lado-a-lado-multiplicador/', component: LLMultiplierHome, permissions: ['llMultiplierBags', 'llMultiplierTrialSigns']},
    {name: 'llMultiplierBagsCreate', path: '/lado-a-lado-multiplicador/bolsas/', component: LLMultiplierBagsCreate, permissions: ['llMultiplierBags']},
    {name: 'llMultiplierBagsModify', path: '/lado-a-lado-multiplicador/bolsas/:id/', component: LLMultiplierBagsModify, permissions: ['llMultiplierBags']},
    {name: 'llMultiplierTrialSignsCreate', path: '/lado-a-lado-multiplicador/carteles/', component: LLMultiplierTrialSignsCreate, permissions: ['llMultiplierTrialSigns']},
    {name: 'llMultiplierTrialSignsModify', path: '/lado-a-lado-multiplicador/carteles/:id/', component: LLMultiplierTrialSignsModify, permissions: ['llMultiplierTrialSigns']},

    {name: 'cart', path: '/carrito/', component: Cart, permissions: ['merchandising'], title: 'Finalizar Pedido'},

    {name: 'orderList', path: '/pedidos/', component: OrderList},
    {name: 'orderDetail', path: '/pedidos/:id/', component: OrderDetail},
    {name: 'rtiDealerKitsModify', path: '/pedidos/:id/', component: OrderDetail},

    {name: 'creditSummary', path: '/creditos/:id/', component: CreditSummary, title: 'Resumen de crédito'},
    {name: 'supervisorCreditSummary', path: '/creditos/', component: CreditSummary},

    {name: 'addressBook', path: '/direcciones/', component: AddressBook, title: 'Direcciones'},
    {name: 'createAddress', path: '/direcciones/nueva/', component: CreateAddress, title: 'Crear dirección'},
    {name: 'updateAddress', path: '/direcciones/:id/', component: UpdateAddress, title: 'Editar dirección'},

    {name: 'profile', path: '/perfil/', component: Profile},

    {name: 'den', path: '/den/', component: DEN},

    {name: 'termsAndConditions', path: '/bases-y-condiciones/', component: TermsAndConditions},
    {name: 'termsAndConditionsAnonymous', path: '/bases-y-condiciones/:token/', component: TermsAndConditions, anonymous: true},

    {name: 'faq', path: '/preguntas-frecuentes/', component: FAQ},

    {name: 'contactForm', path: '/contacto/', component: ContactForm, title: 'Contacto'},

    {name: 'login', path: '', component: Login, anonymous: true},

    {name: '404', path: '', render: () => <ErrorPage status={404} />},
];

export const getAnonymousUrls = () => urlPatterns.filter(({anonymous}) => Boolean(anonymous));
export const getAuthenticatedUrls = user => (
    urlPatterns.filter(({permissions, anonymous}) => {
        if (permissions && !checkPermission(user, permissions)) return false;
        if (anonymous) return false;
        return true;
    })
);

export const reverse = (name, params = {}) => {
    const url = urlPatterns.find(url => url.name === name);
    if (!url) throw new Error(`Invalid url name: ${name}`);

    let {path} = url;

    // Replace provided params
    Object.entries(params).forEach(([key, value]) => {
        path = path.replace(`:${key}`, value);
    });

    // Remove optional params
    path = path.replace(/(:\w+\?)\//g, '');
    return path;
};



// WEBPACK FOOTER //
// ./core/urls.js